import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ArticlesProvider } from './ContextData/ContextData';
/* import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCJ39yuYK4b1fXILmmGtLAz-Fi9JLU5Jv4",
  authDomain: "afriyofa-28325.firebaseapp.com",
  projectId: "afriyofa-28325",
  storageBucket: "afriyofa-28325.firebasestorage.app",
  messagingSenderId: "126924932264",
  appId: "1:126924932264:web:1df95ebe528cfdb8d1ae9d",
  measurementId: "G-J744T7GNCQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

 */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ArticlesProvider>
      <App />
    </ArticlesProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
